<template>
  <PublicView :key="this.$route.params.make">
    <main class="main">
      <div class="site-breadcrumb" style="background: url(/assets/img/breadcrumb/01.jpg)">
        <div class="container">
          <h2 class="breadcrumb-title">Cựa hàng</h2>
        </div>
      </div>

      <div class="shop-area py-120">
        <div class="container">
          <div class="row">
            <div class="col-lg-4">
              <div class="shop-sidebar">
                <div class="shop-widget">
                  <div class="shop-search-form">
                    <h4 class="shop-widget-title">Tìm kiếm</h4>
                    <form action="#">
                      <div class="form-group">
                        <input v-model="query" type="text" class="form-control" placeholder="Search" />
                        <button type="search">
                          <i class="far fa-search"></i>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
                <div class="shop-widget make-filter">
                  <h4 class="shop-widget-title">Hãng xe</h4>
                  <ul class="ul-make">
                    <li>
                      <div class="title-wrap">
                        <div class="make" v-bind:class="{
                          select: select == null && model == null,
                        }" v-on:click="selectMake(null)">
                          Tất cả
                        </div>
                      </div>
                    </li>
                    <li v-for="m in make" :key="m.name">
                      <div class="title-wrap">
                        <div class="make" v-bind:class="{ select: select == m.name }" v-on:click="selectMake(m.name)">
                          {{ m.name }}
                        </div>
                        <div class="show" v-bind:class="{ d: show[m.name] }" v-if="m.model.length > 0"
                          v-on:click="toggleShowMake(m.name)">
                          <i class="fas"></i>
                        </div>
                      </div>
                      <ul style="padding-left: 20px" v-bind:class="{ show: show[m.name] }">
                        <li v-bind:class="{
                          select: isSelectModel(m.name, model),
                        }" v-for="model in m.model" :key="model" v-on:click="selectModel(m.name, model)">
                          {{ model }}
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-lg-8">
              <div class="col-md-12">
                <div class="shop-sort">
                  <h5>
                    Hiển thị {{ (page - 1) * 30 + 1 }}-{{
                      page * 30 + 1 >= productsWithFilter.length
                        ? productsWithFilter.length
                        : page * 30 + 1
                    }}
                    của {{ productsWithFilter.length }} Kết quả
                  </h5>
                  <div class="shop-sort-box">
                    <select class="form-select" v-model="sort">
                      <option value="1">Sắp xếp mặc định</option>
                      <option value="2">Mới nhất trước</option>
                      <option value="3">Giá thấp tới cao</option>
                      <option value="4">Giá cao tới thấp</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 col-lg-4" v-for="p in productsWithPaging" :key="p._id">
                  <div class="shop-item">
                    <div class="shop-item-img">
                      <span class="shop-item-sale">Sale</span>
                      <ImgThumb :src="p.avatar" sizes="(min-width: 768px) 200px, (min-width: 992px) 250px, 300px"
                        width="350,200,250" height="200,100,130" />
                    </div>
                    <div class="shop-item-info">
                      <div>
                        <router-link :to="productLink(p._id, p.alias)">
                          <h4 class="shop-item-title">{{ p.name }}</h4>
                        </router-link>
                      </div>
                      <div>{{ p.make }} {{ p.model }}</div>
                      <div>{{ version(p.year) }}</div>
                      <div class="shop-item-price">
                        {{ numberFormat(p.price) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pagination-area" v-if="maxPage > 1">
                <div aria-label="Page navigation example">
                  <ul class="pagination">
                    <li class="page-item" v-if="page > 2">
                      <span class="page-link" v-on:click="page = 1"><i class="far fa-arrow-left"></i></span>
                    </li>
                    <li class="page-item" v-if="page > 1">
                      <span class="page-link" v-on:click="page = page - 1">{{
                        page - 1
                      }}</span>
                    </li>
                    <li class="page-item active">
                      <span class="page-link">{{ page }}</span>
                    </li>
                    <li class="page-item">
                      <span class="page-link" v-if="maxPage >= page + 1" v-on:click="page = page + 1">{{ page + 1
                      }}</span>
                    </li>

                    <li class="page-item">
                      <span class="page-link" v-if="maxPage >= page + 2" v-on:click="page = maxPage"><i
                          class="far fa-arrow-right"></i></span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </PublicView>
</template>
<script>
const axios = require("axios").default;

import ImgThumb from "@/components/Shared/ImgThumb.vue";
import PublicView from "@/components/PublicView.vue";
export default {
  data() {
    return {
      make: [],
      show: {},
      filter: {},
      sort: 1,
      query: "",
      select: null,
      model: null,
      page: 1,
    };
  },
  components: {
    PublicView,
    ImgThumb,
  },
  mounted() {
    this.getMake();
    document.querySelector("title").innerText = "Alphatech.vn - Cựa hàng Alphatech";
    if (this.$route.params.make) {
      this.select = decodeURIComponent(this.$route.params.make);
      this.model = null;
      this.show[decodeURIComponent(this.$route.params.make)] = true;
      this.filter.parent = decodeURIComponent(this.$route.params.make);
      this.filter.select = null;
    }
  },
  onUpdated() { },
  computed: {
    makeId() {
      return this.$route.params.make;
    },
    products() {
      return this.$store.getters.products;
    },
    productsWithFilter() {
      if (this.products) {
        let result = this.products;
        if (this.query.length > 0) {
          result = result.filter((i) => {
            return (
              (
                i.name.toLowerCase() +
                " " +
                this.version(i.year).toLowerCase()
              ).indexOf(this.query.toLowerCase()) != -1
            );
          });
        }

        if (this.filter.make != null) {
          result = result.filter(
            (i) => i.make.toLowerCase() == this.filter.make.toLowerCase()
          );
        }
        if (this.filter.parent != null) {
          result = result.filter(
            (i) => i.category.alias.toLowerCase() == this.filter.parent.toLowerCase()
          );
        }
        if (this.filter.model != null) {
          result = result.filter(
            (i) => i.model.toLowerCase() == this.filter.model.toLowerCase()
          );
        }
        return result;
      } else {
        return [];
      }
    },
    productsWithPaging() {
      let start = 30 * (this.page - 1);
      let end = start + 30;
      console.log(this.productSort);
      return this.productSort.slice(start, end);
    },
    productSort() {
      let dt = [];
      for (let i = 0; i < this.productsWithFilter.length; i++) {
        dt.push(this.productsWithFilter[i]);
      }
      switch (this.sort) {
        case "2":
          dt.sort(function (a, b) {
            return b.lastUpdate - a.lastUpdate;
          });
          break;
        case "3":
          console.log(this.sort);
          dt.sort(function (a, b) {
            return a.price - b.price;
          });
          break;
        case "4":
          dt.sort(function (a, b) {
            return b.price - a.price;
          });
          break;
      }

      return dt;
    },
    maxPage() {
      return Math.ceil(this.productsWithFilter.length / 30);
    },
  },
  watch: {
    makeId(val) {
      if (val) {
        this.select = decodeURIComponent(val);
        this.model = null;
        this.show[decodeURIComponent(val)] = true;
        this.filter.parent = decodeURIComponent(val);
        this.filter.select = null;
      }
    },
    maxPage(val) {
      if (val > this.page) {
        this.page = 1;
      }
    },
  },
  methods: {
    productLink(id, alias) {
      return "/san-pham/" + alias + "/" + id;
    },
    version(year, pre = "") {
      let result = [];
      for (let i = 0; i < year.length; i++) {
        let text = year[i].year;
        let vers = [];
        for (let ver in year[i].versions) {
          vers.push(year[i].versions[ver].v);
        }
        if (vers.length > 0) {
          result.push(vers.map((i) => pre + i + " " + text).join(", "));
        } else {
          result.push(text);
        }
      }
      return result.length > 0 ? "(" + result.join(", ") + ")" : "";
    },
    numberFormat(num) {
      return new Intl.NumberFormat("vi-VN", {
        style: "currency",
        currency: "VND",
      }).format(num);
    },
    selectMake(makeName) {
      this.select = makeName;
      this.model = null;
      if (makeName != null) {
        this.filter.make = makeName;
      } else {
        delete this.filter.make;
      }
    },
    selectModel(makeName, modelName) {
      console.log("selectModel");
      this.select = null;
      this.model = makeName + modelName;
      console.log(this.model);
      this.filter = { make: makeName.toLowerCase(), model: modelName };
    },
    isSelectModel(makeName, modelName) {
      return this.model == makeName + modelName;
    },
    showMakeStatus(name) {
      if (typeof this.show[name] == "undefined") {
        return false;
      } else {
        return this.show[name];
      }
    },
    toggleShowMake(name) {
      if (typeof this.show[name] == "undefined") {
        this.show[name] = true;
      } else {
        this.show[name] = !this.show[name];
      }
      console.log(this.show[name]);
    },
    async getMake() {
      try {
        let res = await axios.get("/api/make");
        this.make = res.data;
        for (let i = 0; i < this.make.length; i++) {
          this.show[this.make[i].name] = false;
        }
      } catch {
        console;
      }
    },
  },
};
</script>

<style lang="less">
.page-item {
  cursor: pointer;
}

.shop-widget.make-filter {
  .ul-make {
    text-align: left;

    >li {
      margin: 0;

      .title-wrap {
        display: flex;
        cursor: pointer;

        .make {
          flex: 1;

          &.select {
            color: #2db7ff;
          }
        }

        .show {
          i::before {
            content: "\f078";
          }

          &.d {
            i::before {
              content: "\f077";
            }
          }
        }
      }

      ul {
        margin: 0;
        max-height: 0;
        overflow: hidden;
        transition: 1s max-height;

        &.show {
          max-height: initial;
        }

        >li {
          margin: 0;
          cursor: pointer;

          &.select {
            color: #2db7ff;
          }
        }
      }
    }
  }
}
</style>